/**
 * Utilities for parsing Server-Sent Events (SSE) streams
 */

export interface StreamEvent {
  event?: string;
  data?: string;
}

/**
 * Parses a chunk of SSE data and returns an array of parsed events
 * @param chunk - Raw SSE chunk string
 * @returns Array of parsed StreamEvent objects
 */
export const parseSSEChunk = (chunk: string): StreamEvent[] => {
  const events: StreamEvent[] = [];
  const lines = chunk.split('\n');

  let currentEvent: StreamEvent = {};

  for (const line of lines) {
    const trimmedLine = line.trim();

    if (trimmedLine === '') {
      // Empty line signals end of event
      if (currentEvent.event || currentEvent.data) {
        events.push(currentEvent);
        currentEvent = {};
      }
      continue;
    }

    if (trimmedLine.startsWith('event:')) {
      currentEvent.event = trimmedLine.substring(6).trim();
    } else if (trimmedLine.startsWith('data:')) {
      currentEvent.data = trimmedLine.substring(5).trim();
    }
  }

  // Add final event if it exists
  if (currentEvent.event || currentEvent.data) {
    events.push(currentEvent);
  }

  return events;
};
